import { RefObject } from 'react'
import { create } from 'zustand'
import { throttle } from '@/shared/utils/datetimes';
import { storeFutuExchange } from '@/shared/store/exchange';
import { IsValid } from '@/shared/utils/validation';
import { storeFutuUserInfo } from '@/shared/store/userInfo';
import { fundingFeeText } from '@/shared/utils/maths';
import { formatDecimalByPrecision } from '@/shared/utils/formatter';

// 마켓에 소속된 websocket 데이터 처리
const EventBinanceMarket = (message: string) => {
  const data = JSON.parse(message)
  if (data.length > 0) {
    // ticker24
    if (data[0].e === '24hrTicker') {
      // 여기서 정리해서 처리 저장.
      const tmp = data as Binance24hrTicker[]
      //!여기까지는 데이터 옴
      storeFutuWSMarket.getState().setTicker24(tmp)
    } else if (data[0].e === 'markPriceUpdate') {
      const currntTicker = data.filter((el: BinanceMarkPriceUpdate) => el.s === storeFutuExchange.getState().exSymbol)
      if (currntTicker.length !== 0) {
        storeFutuWSMarket.getState().setCurrentHeaderMark(currntTicker[0])
      }
    }
  }
}

interface BinanceWsMarket {
  maxReconnection: number
  reConnCnt: number
  reConnflg: RefObject<boolean>

  socket: RefObject<WebSocket | null> | null
  isConnected: boolean
  ticker24: Map<string, Binance24hrTicker | null>
  headerInfo: BinanceHeaderInfo

  saveSubScribe: string[]

  setTicker24: (tickers: Binance24hrTicker[]) => void
  setCurrentHeaderMark: (info: BinanceMarkPriceUpdate) => void

  connect: () => void
  unConnect: () => void
  sendMessage: (message: string) => void
  Start24hrTicker: () => void

  SetSubscribe: (includestring: string, parmas: string) => void
  DelSubscribe: (includestring: string) => void
}

export const storeFutuWSMarket = create<BinanceWsMarket>((set, get) => ({
  maxReconnection: 5,
  reConnCnt: 0,
  reConnflg: { current: false },

  socket: null,
  isConnected: false,
  messages: '',
  ticker24: new Map<string, Binance24hrTicker>(),
  headerInfo: {
    initPrice: '', // 초기값
    ismaker: false,
    currentPrice: '', // 현재 가격
    ratePrice: '', // 비율
    changePrice: '', // 차이 가격
    markPrice: '', // 마크 가격
    high24: '', // hight 24
    low24: '', // low 24
    volusdt24: '', // 볼륨
    fundingFee: '', // 펀딩피 비율
    nextFundingTime: 0, // 다음 펀딩피 시간
  },

  saveSubScribe: [],
  connect: () => {
    if (get() === undefined) {
      return
    }

    const existingSocket = get().socket?.current
    if (existingSocket) {
      console.log('[WS Futures] is already connected')
      return
    }

    const socket = new WebSocket(process.env.NEXT_PUBLIC_BINANCE_FUTU_SOCKET_URL || '')
    socket.onopen = () => {
      set({ isConnected: true, reConnflg: { current: true } })
      console.log('[WS Futures] connected')
    }

    socket.onclose = () => {
      console.log('[WS Futures] closed')

      setTimeout(() => {
        if (get().reConnflg.current === false) {
          get().socket?.current?.close()
          get().socket = null
          get().connect() // WebSocket 재연결
        }
      }, 3000) // 3초 후 재연결 시도
    }

    socket.onerror = (error) => {
      console.error('WS Futures error:', error)
      set({ isConnected: false })
    }

    socket.onmessage = (event) => {
      EventBinanceMarket(event.data)
    }

    get().socket = { current: socket }
  },

  unConnect: () => {
    const socket = get().socket?.current
    if (socket) {
      // WebSocket 연결 종료
      socket.close()

      // 이벤트 리스너 해제
      socket.onclose = null
      socket.onerror = null
      socket.onmessage = null

      // 상태 업데이트
      set({ socket: null, isConnected: false, reConnflg: { current: false } })
      console.log('[WS Futures] unconnected')
    }
  },
  sendMessage: (message: string) => {
    const { socket, isConnected } = get()
    if (isConnected && socket?.current) {
      socket.current.send(message)
    } else {
      console.warn('WebSocket is not connected. Unable to send message:', message)
    }
  },
  Start24hrTicker: () => {
    const sendmsg = JSON.stringify({
      method: 'SUBSCRIBE',
      params: ['!ticker@arr', '!markPrice@arr'],
      id: 1,
    })
    get().SetSubscribe('!ticker@arr', sendmsg)
    get().sendMessage(sendmsg)
  },

  setTicker24: throttle((tickers: Binance24hrTicker[]) => {
    const ticker24Tmp = get().ticker24
    if (ticker24Tmp === null) {
      if (storeFutuExchange.getState().exchangeInfo === null) {
        return
      }

      const { exchangeInfo } = storeFutuExchange.getState()
      if (exchangeInfo !== null && IsValid(exchangeInfo) === true) {
        // const tmp = Array.from(exchangeInfo.keys() || [])
        // get().setTickerSymbol(tmp)
      }
      return
    }

    if (tickers.length === 0) {
      return
    }

    const { exchangeInfo } = storeFutuExchange.getState()
    tickers?.forEach((ticker: Binance24hrTicker) => {
      if (ticker.s.endsWith('USDT')) {

        const tmp = exchangeInfo?.get(ticker.s)
        if (tmp !== undefined) {
          if (tmp.status === 'TRADING') {
            ticker24Tmp?.set(ticker.s, ticker)
          }
        }
      }
    })

    const tmpticker = new Map(ticker24Tmp)

    set({ ticker24: new Map(ticker24Tmp) })
    storeFutuUserInfo.getState().getWSTicker(tmpticker as Map<string, Binance24hrTicker>)
  }, 700),

  setCurrentHeaderMark: throttle((info: BinanceMarkPriceUpdate) => {
    const { exSymbol } = storeFutuExchange.getState()
    const markPrice = formatDecimalByPrecision(info.p, Number(storeFutuExchange.getState().getFutuExchangeInfo(exSymbol)?.tickSize ?? 0))
    const send = get().headerInfo
    send.markPrice = String(markPrice) // info.p

    send.fundingFee = fundingFeeText(info.r)
    send.nextFundingTime = info.T
  }, 1000),
  SetSubscribe: throttle((includestring: string, parmas: string) => {
    set((state) => {
      // 중복 여부 확인
      if (state.saveSubScribe.includes(includestring)) {
        return state // 이미 존재하는 경우 상태 변경 없이 기존 상태 반환
      }
      // 중복이 아니면 추가
      return {
        saveSubScribe: [...state.saveSubScribe, parmas],
      }
    })
  }, 1000),
  DelSubscribe: throttle((includestring: string) => {
    set((state) => {
      const filteredSubScribe = state.saveSubScribe.filter((sub) => !sub.includes(includestring))
      // 새로운 배열에 `parmas`를 추가하여 상태를 업데이트
      return {
        saveSubScribe: [...filteredSubScribe],
      }
    })
  }, 1000)
}))
